import Swiper from 'swiper';
import 'swiper/bundle';
import 'swiper/swiper-bundle.css';
const initBlock = function( $block ) {
	$block.each( function() {
		const $sectionInstance = $( this );
		const $slider = $sectionInstance.find( '.js-hero-banners-slider' );

		if ( !$slider.length || $slider[0].swiper ) {
			return;
		}

		const slidesCount = $slider.find( '.swiper-slide' ).length;

		new Swiper( $slider[0], {
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
			slidesPerView: 1,
			spaceBetween: 0,
			speed: 1000,
			loop: slidesCount > 1,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false
			},
			navigation: {
				nextEl: $sectionInstance.find( '.swiper-button-next' )[0],
				prevEl: $sectionInstance.find( '.swiper-button-prev' )[0],
			},
		} );
	} );
};

app.loadBlock( initBlock, 'hero', '.section-hero' );

if ( module.hot ) {
	module.hot.accept();
}
